export default function histogramSpec(data, field, title, markColor="#00bfa5", highlightColor="#ffab00") {
  return {
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    width: "container",

    data: {
      name: "whole",
      values: data,
    },
    encoding: {
      x: { field, title, bin: true, type: "quantitative" },
      y: { aggregate: "count" }
    },
    layer: [
      {
        params: [
          //   {"name": "brush", "select": {"type": "interval", "encodings": ["y"]}},
          {
            name: "select",
            select: { type: "interval", encodings: ["x"] },
          },
        ],
        mark: { type: "bar", tooltip: true, color:markColor },
        // encoding: {
        //   x: { field, title, bin: true, type: "quantitative" },
        //   y: { aggregate: "count" },
        // },
      },
      {
        // data: {
        //   name: "partial",
        //   values: [],
        // },
        transform: [
          {
            filter: { field: "responseId", oneOf: [] },
          },
        ],
        mark: { type: "bar", color: highlightColor },
        // encoding: {
        //   x: { field, title, bin: true, type: "quantitative" },
        //   y: { aggregate: "count" },
        // },
      },
    ],
  };
}

export function addFilterSignal(vegaSpec) {
  //vega spec

  vegaSpec.signals.push({
    name: "filter_selection",
    value: [],
  });
  const data = vegaSpec.data.find((d) => d.name === "data_1");
  if (!data) {
    return;
  }
  data.transform[0].expr =
    'indexof(filter_selection, datum["responseId"]) !== -1';
}
